import React from 'react';
import classnames from 'classnames';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import useStyles from './style';
import { IBreadcrumbsProps } from './types';

function Breadcrumbs({ className, routesConfig }: IBreadcrumbsProps) {
  const classes = useStyles();
  const breadcrumbs = useBreadcrumbs(routesConfig, { disableDefaults: true });
  return (
    <div className={classnames(classes.root, className)}>
      <ul className={classes.list}>
        {breadcrumbs.map(({ match, breadcrumb }) => (
          <React.Fragment key={match.url}>{breadcrumb}</React.Fragment>
        ))}
      </ul>
    </div>
  );
}

export default React.memo(Breadcrumbs);
